export default [
  {
    name: 'Alberta',
    iso2Code: 'AB',
  },
  {
    name: 'British Columbia',
    iso2Code: 'BC',
  },
  {
    name: 'Manitoba',
    iso2Code: 'MB',
  },
  {
    name: 'New Brunswick',
    iso2Code: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    iso2Code: 'NL',
  },
  {
    name: 'Northwest Territories',
    iso2Code: 'NT',
  },
  {
    name: 'Nova Scotia',
    iso2Code: 'NS',
  },
  {
    name: 'Nunavut',
    iso2Code: 'NU',
  },
  {
    name: 'Ontario',
    iso2Code: 'ON',
  },
  {
    name: 'Prince Edward Island',
    iso2Code: 'PE',
  },
  {
    name: 'Quebec',
    iso2Code: 'QC',
  },
  {
    name: 'Saskatchewan',
    iso2Code: 'SK',
  },
  {
    name: 'Yukon',
    iso2Code: 'YT',
  },
];
